// Existing Credits/Liabilities (Verbindlichkeiten)
// Credit type constants matching translation file: EXISTING_LOANS.TYPES.{key}
export const DISPOSITIONSKREDIT = 'dispositionskredite' as const;
export const GESCHAEFTSKREDIT = 'geschaeftskredite' as const;
export const IMMOBILIENDARLEHEN = 'immobiliendarlehen' as const;
export const KONTOKORRENTKREDIT = 'kontokorrentkredite' as const;
export const KREDITKARTE = 'kreditkarten' as const;
export const LEASING = 'leasings' as const;
export const RATENKREDIT = 'ratenkredite' as const;
export const SONSTIGE_VERBINDLICHKEITEN = 'sonstigeVerbindlichkeiten' as const;

export const LoanTypeKeys = [
    DISPOSITIONSKREDIT,
    GESCHAEFTSKREDIT,
    IMMOBILIENDARLEHEN,
    KONTOKORRENTKREDIT,
    KREDITKARTE,
    LEASING,
    RATENKREDIT,
    SONSTIGE_VERBINDLICHKEITEN,
] as const;

export type LoanType = (typeof LoanTypeKeys)[number];
